module.exports = __webpack_public_path__ + "img/title.80258ae1.png";